/*
 * @Author: wanghf
 * @Date: 2017-12-19 11:02:02
 * @Description: vuex user
 * @Last Modified by: wanghf
 * @Last Modified time: 2022-05-31 10:08:30
 */
import store from '@/vuex'
import { Message } from 'element-ui';
import { query } from '@/api/modules/certification.js'
import { getExpireCertification } from "@/api/modules/certification"

const state = {
  // 商户证件信息是否过期
  certificationInfo: {},
  requested: false,
  // 法人
  legal: {
    passedList: [], // 审核已通过
    newList: [], // 新增
    deleteList: [] // 删除
  },
  // 股东
  director: {
    passedList: [],
    newList: [],
    deleteList: []
  },
  // 受益人
  beneficial: {
    passedList: [],
    newList: [],
    deleteList: []
  }
}

const mutations = {
  setCertificationInfo(state, data) {
    state.certificationInfo = data
  },
  setApprovedPerson(state, data) {
    const { holderUserInfo, beneficiaryInfo } = data;
    state.requested = true
    state.legal.passedList = []
    state.director.passedList = _.cloneDeep(holderUserInfo.filter(item => item.status === "PASSED"))
    state.beneficial.passedList = _.cloneDeep(beneficiaryInfo.filter(item => item.status === "PASSED"))
  },
  setPersonChange(state, data) {
    const { userType, personalId } = data;
    if(userType === "1") {
      const idx = state.legal.newList.findIndex(i => i.personalId == personalId)
      if(idx === -1) {
        state.legal.newList.push(data)
      } else {
        state.legal.newList.splice(idx, 1, data)
      }
    } else if(userType === "2") {
      const idx = state.director.newList.findIndex(i => i.personalId == personalId)
      if(idx === -1) {
        state.director.newList.push(data)
      } else {
        state.director.newList.splice(idx, 1, data)
      }
    } else if(userType === "3") {
      const idx = state.beneficial.newList.findIndex(i => i.personalId == personalId)
      if(idx === -1) {
        state.beneficial.newList.push(data)
      } else {
        state.beneficial.newList.splice(idx, 1, data)
      }
    }
  },
  delete(state, data) {
    const { userType, id, deleteType } = data;
    if(userType === "1") {
      if(deleteType === "delNew") {
        const idx = state.legal.newList.findIndex(i => i.personalId == id)
        state.legal.newList.splice(idx, 1)
      } else {
        const idx = state.legal.passedList.findIndex(i => i.personalId == id)
        state.legal.passedList.splice(idx, 1)
        state.legal.deleteList.push(id)
      }
    } else if(userType === "2") {
      if(state.director.passedList.length + state.director.newList.length <= 1) {
        return Message.error("股东人数必须 >= 1")
      }
      if(deleteType === "delNew") {
        const idx = state.director.newList.findIndex(i => i.personalId == id)
        state.director.newList.splice(idx, 1)
      } else {
        const idx = state.director.passedList.findIndex(i => i.personalId == id)
        state.director.passedList.splice(idx, 1)
        state.director.deleteList.push(id)
      }
    } else if(userType === "3") {
      if(state.beneficial.passedList.length + state.beneficial.newList.length <= 1) {
        return Message.error("受益人人数必须 >= 1")
      }
      if(deleteType === "delNew") {
        const idx = state.beneficial.newList.findIndex(i => i.personalId == id)
        state.beneficial.newList.splice(idx, 1)
      } else {
        const idx = state.beneficial.passedList.findIndex(i => i.personalId == id)
        state.beneficial.passedList.splice(idx, 1)
        state.beneficial.deleteList.push(id)
      }
    }
  },
  updateSingleInfo(state, id) {
    const list = state.certificationInfo.alertInfoDTO.identificationInvalidDTOS
    const info = list.find(item => item.renewId === id);
    info && (info.frontTag = true);
  }
}

const actions = {
  // 获取商户证件信息过期列表
  getCertificationInfo: async({ commit }) => {
    const data = await getExpireCertification({
      clientId: store.getters['user/accountCenterInfo'].clientId
    })
    commit('setCertificationInfo', data || {})
  },
  // 获取已审核通过的法人、股东、受益人
  getApprovedPerson: async ({ commit }, data) => {
    const params = {
      clientId: store.getters['user/accountCenterInfo'].clientId,
      queryType: 'COMPANY'
    }
    await query(params).then(res => {
      const {
        holderUserInfo,
        beneficiaryInfo,
      } = res
      commit('setApprovedPerson', {
        holderUserInfo: holderUserInfo.userInfos,
        beneficiaryInfo: beneficiaryInfo.userInfos,
      })
    })

  },
  // 变更法人、股东、受益人
  changePerson: ({ commit }, params) => {
    commit('setPersonChange', params)
  },
  delPerson: ({ commit }, params) => {
    commit('delete', params)
  },
}

const getters = {
  certificationInfo: state => state.certificationInfo,
  requested: state => state.requested,
  legal: state => state.legal,
  director: state => state.director,
  beneficial: state => state.beneficial,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
